module.exports = __webpack_public_path__ + "static/media/kpmg.1b9b406c.png";